/* eslint-disable no-console */
/**
 * GeoRedirect component
 */
export const initGeoRedirect = async () => {

	/**
	 * Set a cookie
	 *
	 * @param {string} name - The name of the cookie
	 * @param {string} value - The value of the cookie
	 * @param {number} days - The number of days to set the cookie for
	 */
	function setCookie( name, value, days ) {

		const date = new Date();
		date.setTime( date.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
		document.cookie = `${name  }=${  value  };expires=${  date.toUTCString()  };path=/`;

	}

	/**
	 * Get a cookie
	 *
	 * @param {string} name - The name of the cookie
	 * @return {boolean} - True if the cookie exists, false otherwise
	 */
	function getCookie( name ) {

		return document.cookie.split( ';' ).some( c => c.trim().startsWith( `${name  }=` ) );

	}

	try {

		const settingsResponse = await fetch( window.geoRedirectData.apiUrl.replace( '/geo-check', '/geo-settings' ) );
		if ( !settingsResponse.ok ) {

			throw new Error( 'Network response was not ok' );

		}
		const settings = await settingsResponse.json();

		if ( !settings.is_enabled ) {

			console.log( 'Geo Redirect Disabled' );
			return;

		}

		const geoResponse = await fetch( window.geoRedirectData.apiUrl );

		if ( !geoResponse.ok ) {

			throw new Error( 'Network response was not ok' );

		}

		const data = await geoResponse.json();

		console.log( 'Geo Redirect Check Data:', data );

		const hasRedirectCookie = getCookie( 'wpml_us_auto_redirect' );

		// Log API response for debugging
		console.log( 'Geo Redirect Check API Response:', {
			'Geo Redirect Settings:': settings,
			country: data.country,
			hasRedirectCookie: hasRedirectCookie,
			redirect_url: data.redirect_url,
			current_url: window.location.href,
			api_status: 'working',
			'window.geoRedirectData.apiUrl': window.geoRedirectData.apiUrl,
			is_enabled: settings.is_enabled,
			is_test_mode: settings.is_test_mode
		} );

		if ( data.country === 'US' &&
			data.redirect_url !== window.location.href &&
			!hasRedirectCookie ) {

			console.log( 'Redirecting to:', data.redirect_url );

			if ( settings.is_test_mode ) {

				console.log( 'TEST MODE: Would redirect to:', data.redirect_url );
				console.log( 'TEST MODE: Would set cookie wpml_us_auto_redirect' );
				return;

			}

			// Set the cookie before redirecting
			setCookie( 'wpml_us_auto_redirect', '1', 30 );

			// Redirect
			window.location.href = data.redirect_url;
			console.log( 'Redirecting to:', data.redirect_url );

		}

	} catch ( error ) {

		console.error( 'Error during geo check:', error );

	}

};